<template>
  <nav class="sm:w-20 flex flex-col z-50 shrink-0 bg-[#153838] w-16 border-white/5 border-r pt-8 pb-8 items-center h-screen">
    <RouterLink
      to="/dashboard"
      class="w-12 h-12 rounded-2xl bg-gradient-to-br from-white/10 to-white/5 flex items-center justify-center mb-8 border border-white/10 shadow-xl shadow-black/20 backdrop-blur-md group cursor-pointer"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-[#ecd79f] w-6 h-6 group-hover:scale-110 transition-transform duration-500">
        <path d="M12 7v14"></path>
        <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>
      </svg>
    </RouterLink>

    <div class="flex flex-col gap-6 w-full items-center flex-1">
      <RouterLink
        to="/dashboard"
        class="p-3 rounded-xl transition-all duration-300"
        :class="isDashboard ? 'text-[#ecd79f] bg-white/10 shadow-inner border border-white/5 relative' : 'text-white/40 hover:text-white hover:bg-white/10'"
      >
        <div v-if="isDashboard" class="absolute -right-1 -top-1 w-2 h-2 bg-[#ecd79f] rounded-full"></div>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
          <rect width="7" height="7" x="3" y="3" rx="1"></rect>
          <rect width="7" height="7" x="14" y="3" rx="1"></rect>
          <rect width="7" height="7" x="14" y="14" rx="1"></rect>
          <rect width="7" height="7" x="3" y="14" rx="1"></rect>
        </svg>
      </RouterLink>
      <RouterLink
        to="/library"
        class="p-3 rounded-xl transition-all duration-300"
        :class="isLibrary ? 'text-[#ecd79f] bg-white/10 shadow-inner border border-white/5 relative' : 'text-white/40 hover:text-white hover:bg-white/10'"
      >
        <div v-if="isLibrary" class="absolute -right-1 -top-1 w-2 h-2 bg-[#ecd79f] rounded-full"></div>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
          <path d="m16 6 4 14"></path>
          <path d="M12 6v14"></path>
          <path d="M8 8v12"></path>
          <path d="M4 4v16"></path>
        </svg>
      </RouterLink>
      <RouterLink
        to="/audio-content"
        class="p-3 rounded-xl transition-all duration-300"
        :class="isAudioContent ? 'text-[#ecd79f] bg-white/10 shadow-inner border border-white/5 relative' : 'text-white/40 hover:text-white hover:bg-white/10'"
      >
        <div v-if="isAudioContent" class="absolute -right-1 -top-1 w-2 h-2 bg-[#ecd79f] rounded-full"></div>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
          <path d="M9 18V5l12-2v13"></path>
          <circle cx="6" cy="18" r="3"></circle>
          <circle cx="18" cy="16" r="3"></circle>
        </svg>
      </RouterLink>
      <RouterLink
        to="/games"
        class="p-3 rounded-xl transition-all duration-300"
        :class="isGames ? 'text-[#ecd79f] bg-white/10 shadow-inner border border-white/5 relative' : 'text-white/40 hover:text-white hover:bg-white/10'"
      >
        <div v-if="isGames" class="absolute -right-1 -top-1 w-2 h-2 bg-[#ecd79f] rounded-full"></div>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
          <path d="M6 12h4"/><path d="M8 10V6"/><path d="M15 13h.01"/><path d="M18 11h.01"/><path d="M17 16H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2Z"/>
        </svg>
      </RouterLink>
      <RouterLink
        to="/feed"
        class="p-3 rounded-xl transition-all duration-300"
        :class="isFeed ? 'text-[#ecd79f] bg-white/10 shadow-inner border border-white/5 relative' : 'text-white/40 hover:text-white hover:bg-white/10'"
      >
        <div v-if="isFeed" class="absolute -right-1 -top-1 w-2 h-2 bg-[#ecd79f] rounded-full"></div>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
          <path d="M12 19V5"/><path d="m5 12 7-7 7 7"/>
        </svg>
      </RouterLink>
      <RouterLink
        to="/settings"
        title="Postavke"
        class="p-3 rounded-xl transition-all duration-300"
        :class="isSettings ? 'text-[#ecd79f] bg-white/10 shadow-inner border border-white/5 relative' : 'text-white/40 hover:text-white hover:bg-white/10'"
      >
        <div v-if="isSettings" class="absolute -right-1 -top-1 w-2 h-2 bg-[#ecd79f] rounded-full"></div>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/>
        </svg>
      </RouterLink>
      <RouterLink
        v-if="auth.isSuperAdmin"
        to="/users"
        title="Users"
        aria-label="Users"
        class="p-3 rounded-xl transition-all duration-300"
        :class="isUsers ? 'text-[#ecd79f] bg-white/10 shadow-inner border border-white/5 relative' : 'text-white/40 hover:text-white hover:bg-white/10'"
      >
        <div v-if="isUsers" class="absolute -right-1 -top-1 w-2 h-2 bg-[#ecd79f] rounded-full"></div>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
          <path d="M16 3.128a4 4 0 0 1 0 7.744"></path>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
          <circle cx="9" cy="7" r="4"></circle>
        </svg>
      </RouterLink>
      <button type="button" class="p-3 text-white/40 hover:text-white hover:bg-white/10 rounded-xl transition-all duration-300">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
          <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
          <circle cx="9" cy="9" r="2"></circle>
          <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
        </svg>
      </button>
    </div>

    <div class="mt-auto flex flex-col gap-4 items-center">
      <button
        type="button"
        title="Odjavi se"
        aria-label="Odjavi se"
        class="p-3 text-white/40 hover:text-white hover:bg-white/10 rounded-xl transition-all duration-300"
        @click="logout"
      >
        <iconify-icon icon="solar:logout-3-linear" class="text-xl" aria-hidden="true" />
      </button>
      <RouterLink
        to="/profile"
        :title="auth.getName ? `${auth.getName} · Moj profil` : 'Moj profil'"
        aria-label="Moj profil"
        class="w-9 h-9 rounded-full overflow-hidden transition-all duration-300"
        :class="isProfile ? 'ring-2 ring-[#ecd79f]/40 ring-offset-2 ring-offset-[#153838]' : 'opacity-90 hover:opacity-100'"
      >
        <UserAvatar class="h-full w-full text-xs" />
      </RouterLink>
    </div>
  </nav>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import UserAvatar from '@/components/app/dashboard/UserAvatar.vue';
import { useAuthStore } from '@/store/auth/index.js';

const route = useRoute();
const isDashboard = computed(() => route.path === '/dashboard' || route.path === '/');
const isLibrary = computed(() => route.path.startsWith('/library'));
const isAudioContent = computed(() => route.path.startsWith('/audio-content'));
const isGames = computed(() => route.path.startsWith('/games'));
const isFeed = computed(() => route.path.startsWith('/feed'));
const isSettings = computed(() => route.path.startsWith('/settings'));
const isUsers = computed(() => route.path.startsWith('/users'));
const isProfile = computed(() => route.path.startsWith('/profile'));

const auth = useAuthStore();

onMounted(() => auth.syncUser());

function logout() {
  auth.logout();
}
</script>
